export var DictionaryType;
(function (DictionaryType) {
    DictionaryType["NONE"] = "NONE";
    DictionaryType["SINGLE"] = "SINGLE";
    DictionaryType["SHARED"] = "SHARED";
    DictionaryType["VERTEX"] = "VERTEX";
    DictionaryType["MORTON"] = "MORTON";
    DictionaryType["FSST"] = "FSST";
})(DictionaryType || (DictionaryType = {}));
//# sourceMappingURL=dictionaryType.js.map